export default (state = {}, action) => {
  switch (action.type) {
    case 'VALIDATIONBREAKDOWN':
      return action.payload;
    default:
      return state;
  }
};
